<div animate.enter="fade-in" class="p-4 border-b flex flex-col gap-3 w-full">
    <div class="flex gap-3 items-center justify-end">
        <button
            (click)="back.emit()"
            class="border border-gray-300 rounded-md px-2 py-1 flex gap-2 items-center justify-center w-max hover:bg-gray-50 transition-colors"
        >
            <app-icon name="ic:sharp-keyboard-return" class="text-gray-600" />
            <p class="text-sm">이전으로</p>
        </button>
        <app-document-back-button />
    </div>
    <div class="flex flex-col gap-2">
        @if (currentChild(); as currentChild) {
            @if (currentChild.child; as child) {
                <div class="flex gap-2 items-center">
                    <p class="text-gray-800 font-medium">{{ child.name }}</p>
                    <div class="bg-gray-200 w-px h-3"></div>
                    <p class="text-gray-800 text-sm">
                        {{ child.gender === "MALE" ? "남" : "여" }}
                    </p>
                    <p class="text-gray-400 text-sm">
                        {{ child.birth | date: "yy.MM.dd" }} ({{
                            child.koreanAge
                        }})
                    </p>
                </div>
                <div class="flex w-full justify-between items-center">
                    <div class="flex gap-2 items-center">
                        <app-icon
                            name="material-symbols:call"
                            class="text-primary !size-4"
                        />
                        @if (child.contact; as contact) {
                            <p class="text-sm text-gray-600">
                                {{ contact | contact }}
                            </p>
                        } @else {
                            -
                        }
                    </div>
                    @if (tickets()?.length; as count) {
                        <p class="text-sm text-gray-600">
                            서비스
                            <span class="ml-1 text-primary">{{
                                count | number
                            }}</span>
                        </p>
                    }
                </div>
            }
        }
    </div>
</div>
